export default {
  promote: {
    label: 'Promoted Product Assets',
    describe: 'Information Management of Promoted Products',
    table: {
      listEmpty: {
        describe: "You don't have any promoted product yet, start adding now!",
      },
      operation: {
        rules: 'The Product Name cannot be empty.',
        edittips: 'Edit',
        refresh: 'Refresh',
        deletes: 'Delete',
        deletetips:
          'This product has associated creative and cannot be deleted.',
        delete: {
          label: 'Delete this Product',
          describe: "This can't be undone. Are you sure to delete?",
        },
      },
      ios: {
        rules: 'Please input the product name for iOS',
        package: 'Please input the package name for iOS',
        description: 'Please input the description for iOS',
      },
      android: {
        rules: 'Please input the product name for Android',
        package: 'Please input the package name for Android',
        description: 'Please input the description for Android',
      },
      website: {
        description: 'Please input the description.',
        rules: 'Please input the product name.',
      },
      error: 'Please verify the redirect URL is in a valid format',
      upload: {
        rules: 'Icon File Size cannot exceed {fileSize}',
      },
      platforminfo: 'Platform',
      name: 'Product Name',
      operations: 'Operations',
      updatetime: 'Updated Time',
    },
    rules: {
      placeholder: 'URL cannot be empty',
    },
    icon: {
      rules: 'Icon cannot be empty',
    },
    info: 'Associated Promoted Products',
    filter: {
      placeholder: 'Search by Product Name or Package Name',
      platform: 'Platform',
    },
    edit: {
      label: 'Edit Promoted Product Information',
      package: 'Package Name',
      url: 'URL',
      icon: 'Icon',
    },
    wxgame: {
      title: 'WeChat MiniGame',
      appid: 'MiniGame APPID',
      name: 'MiniGame Name',
      requiredTips: 'Please enter content',
      icon: 'Icon',
    },
  },
}
